export const snappyEaseInOut = [0.785, 0.135, 0.15, 0.86] as const
